import React, { useState, useEffect } from 'react'
import { BtnAcaoLink, Visualizar } from '../Acoes';
import './style/linhaDoTempo.css';
import moment from 'moment';

export default function Timeline({ dados, ...props }) {
    const [timelineAgrupada, setTimelineAgrupada] = useState([]);
    const [anosOrdenados, setAnosOrdenados] = useState([]);
    function extrairAno(dataString) {
        const partesData = dataString.split(' ')[0].split('/');
        return partesData[2]; // Retorna o ano (terceira parte)
    }

    const agruparPorAno = (eventos) => {
        return dados.reduce((acc, item) => {
            const ano = extrairAno(item.data);
            if (!acc[ano]) {
                acc[ano] = [];
            }
            acc[ano].push(item);
            return acc;
        }, {});
    };

    useEffect(() => {
        if (dados && dados.length > 0) {
            const agrupamento = agruparPorAno([...dados]);
            const anosOrdenadosArr = Object.keys(agrupamento).sort((a, b) => Number(b) - Number(a));
            setAnosOrdenados(anosOrdenadosArr);
            setTimelineAgrupada(agrupamento);
        } else
            setTimelineAgrupada([]);
    }, dados)



    return (
        <div className="timeline-container">
            {anosOrdenados?.length > 0 ? anosOrdenados.map(x => {
                return <React.Fragment>
                    <React.Fragment>
                        <div key={x} className="timeline-event timeline-year">
                            <div className="timeline-date">
                            </div>
                            <div className="timeline-content">
                                <div className="timeline-icon">
                                    <span>{x}</span>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                    {timelineAgrupada[x].map((event, index) => (
                        <div key={index} className="timeline-event">
                            <div className="timeline-date">
                                {moment(event.data, 'DD/MM/YYYY HH:mm').format('LL')}
                            </div>
                            <div className="timeline-content">
                                <div className="timeline-icon">
                                    <span className={event.icone} />
                                </div>
                                <div className='timeline-item-wrapper'>
                                    <div className='timeline-event-header'>
                                        <div class="timeline-text"><span class="timeline-user" style={{ fontSize: '15px' }}>{event.evento}</span>
                                            <span class="" style={{ fontSize: '15px', color: '#7b7b7b', fontWeight: 500 }}> no dia {moment(event.data, 'DD/MM/YYYY HH:mm').format('LLL')}</span>
                                        </div>
                                        <div className='d-none-print'>
                                            <BtnAcaoLink icone="icon-File-Search fs-15" texto="Visualizar" to={event.url_visualizar} target='_blank' />
                                        </div>
                                    </div>
                                    {event.conteudo && (
                                        <div className="timeline-comment">
                                            {event.conteudo}
                                            <div className='flex-row mt-1'>
                                                {event.siglas && event.siglas.map(x => <span className='timeline-socio'>{x}</span>)}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                    }
                </React.Fragment>
            }) :
                <div className='no-data-timeline mt-40'>
                    <span className="icon-File-ClipboardFileText" />
                    <p>Não Há Registros</p>
                </div>}
        </div >
    );
}